
const Paginate = ({ dataPerPage, totalData, paginate, previousPage, nextPage, currentPage }) => {
    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(totalData / dataPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderLi = (number) => {
        const className = number === currentPage ? 'page-number active' : 'page-number'
        return <li onClick={() => paginate(number)} key={number} className={className}>
            {number}
        </li>
    }


    return (
        <div className="pagination-container">
            <ul className="pagination">
                {currentPage !== 1 &&
                    <li onClick={previousPage} className="page-number prev">
                        قبلی
                    </li>
                }

                {pageNumbers.map((number) => (renderLi(number)))}

                {currentPage !== Math.ceil(totalData / dataPerPage) &&
                    <li onClick={nextPage} className="page-number next">
                        بعدی
                    </li>
                }
            </ul>
        </div>
    );
};

export default Paginate;